import * as React from "react";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import isEmpty from "lodash-es/isEmpty";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import ListSubheader from "@mui/material/ListSubheader";
import Grid from "@mui/material/Grid";

import { ReactComponent as SearchIcon } from "../../icons/Search24.svg";

import Paper from "@mui/material/Paper";
import Chip from "@mui/material/Chip";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import Button from "@mui/material/Button";
import InputLabel from "@mui/material/InputLabel";

import { ReactComponent as TimerIcon } from "../../icons/Timer24.svg";

import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";
import { doService } from "../../services/ServiceHelper";
import {
  findSchoolUsers,
  getStudentSummary,
  getTeacherSummary,
} from "../../services/UserService";
import {
  getEventStartTime,
  getEventEndTime,
} from "../../services/EventService";
import {
  calculateConsequences,
  buildScores,
  saveScores,
} from "../../services/ScoreService";
import { getYYYYMMDD } from "../../services/DateService";

import { getPassStatusText, createBoomerang } from "../../services/PassService";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { ReactComponent as ExpandMoreIcon } from "../../icons/ExpandMore24.svg";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TableRowNoResults from "../TableRowNoResults";
import { getPeriodName } from "../../services/SchoolService";
import TableContainer from "@mui/material/TableContainer";
import {
  StripedTableCell,
  StripedTableRow,
} from "../StripedTable";
import { isStringEmpty } from "../../services/StringService";
import { TableHead } from "@mui/material";
import { useScoreCategories } from "../../hooks/useScoreCategories";
import { showToast, showOptions } from "../../components/ATPDialogs";
import Select from "@mui/material/Select";

export default function SearchBar() {
  const navigate = useNavigate();

  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();

  const [_open, setOpen] = React.useState(false);
  const [_options, setOptions] = React.useState([]);
  const [_loading, setLoading] = React.useState(false);
  const [_searchText, setSearchText] = React.useState("");

  const [_dialogOpen, setDialogOpen] = React.useState(false);

  const [_selectedUser, setSelectedUser] = React.useState({});
  const [_studentActivities, setStudentActivities] = React.useState([]);
  const [_studentPasses, setStudentPasses] = React.useState([]);
  const [_studentEvents, setStudentEvents] = React.useState([]);
  const [_studentScores, setStudentScores] = React.useState([]);
  const [, setStudentCourses] = React.useState([]);

  const [_teacherActivities, setTeacherActivities] = React.useState([]);
  const [, setTeacherPasses] = React.useState([]);

  const isActivitiesEnabled = () => {
    return _school != null && _school.activitiesEnabled === "Y";
  };
  const { categories: _scoreCategories } = useScoreCategories(_school, _jwt);
  const [_feature, setFeature] = React.useState("A");

  const STATUS_PAST_TIMEOUT = 700;

  const handleOpen = () => {
    setOpen(true);

    if (_options.length > 0) {
      return;
    }

    setLoading(true);
    doService(findSchoolUsers(_school, _jwt), (results) => {
      // add label to results, and populate map
      for (const result of results.data) {
        if (result.priority === 500) {
          let title = `${result.last_name}, ${result.first_name}`;

          if (!isEmpty(result.mi)) {
            title += ` ${result.mi}.`;
          }

          title += ` (${result.grade})`;

          if (!isEmpty(result.externalId)) {
            title += ` [${result.externalId}]`;
          }

          result.title = title;
        } else {
          result.title = `${result.last_name}, ${result.first_name} (Faculty)`;
        }
      }
      setOptions(results.data);
      setLoading(false);
    });
  };

  const handleClose = () => {
    setOpen(false);
    setOptions([]);
    setSearchText("");
  };

  const onChangeUser = (event, userObj) => {
    // userObj can be null
    if (userObj == null) {
      return;
    }

    setSelectedUser(userObj);
    setDialogOpen(true);
    loadUser(userObj);
  };

  const loadUser = (userObj) => {
    // load the data based on the user.
    if (userObj.priority === 500) {
      doService(getStudentSummary(_school, _jwt, userObj.eid), (results) => {
        setStudentActivities(results.data.activities);

        calcPassTimeRemain(results.data.passes);
        setStudentPasses(results.data.passes);
        setStudentEvents(results.data.events);
        setStudentCourses(results.data.courses);
        setStudentScores(results.data.scores);
      });
    } else {
      doService(getTeacherSummary(_school, _jwt, userObj.eid), (results) => {
        setTeacherActivities(results.data.activities);
        setTeacherPasses(results.data.passes);
      });
    }
  };

  const onCloseDialog = () => {
    setDialogOpen(false);
    setSelectedUser({});
  };

  const onClickCloseDialog = () => {
    onCloseDialog();
  };

  const onClickViewStudentCalendar = () => {
    navigate(`/faculty/student-calendar/${_selectedUser.eid}`);
  };

  const calcPassTimeRemain = (passes) => {
    for (let pass of passes) {
      const dateCurrent = dayjs();

      let dateTimeout = dayjs(pass.approved_at);
      dateTimeout = dateTimeout.add(pass.timeout, "minute");

      const dateTimeoutNum = parseInt(dateTimeout.format("HHmmss"));
      const dateCurrentNum = parseInt(dateCurrent.format("HHmmss"));

      const dateTimeoutObj = dayjs(
        `2022-04-17T${dateTimeout.format("HH:mm:ss")}`,
      );
      const dateCurrentObj = dayjs(
        `2022-04-17T${dateCurrent.format("HHmmss")}`,
      );

      console.log("CURR:" + dateCurrentNum);
      console.log("TIMEOUT:" + dateTimeoutNum);

      let seconds = dateTimeoutObj.diff(dateCurrentObj, "second");
      console.log(seconds);
      if (seconds < 0) {
        seconds = 0;
        pass.status = STATUS_PAST_TIMEOUT;
      }
      pass.timeRemainSeconds = seconds;
    }
  };


  const doCalculateConsequences = async (category, studentEids, period) => {
    let consequenceMap = {};
    const scoreCategoryId = category.id;

    await doService(
      calculateConsequences(
        _school,
        _jwt,
        studentEids,
        scoreCategoryId,
        period,
      ),
      (results) => {
        for (let result of results.data) {
          consequenceMap[result.studentEid] = result;
        }
        return consequenceMap;
      },
      null,
      null,
      () => {},
    );
    doQuickSave(category, "XX", studentEids, consequenceMap);
  };

  const getReasonsOptions = (reasons) => {
    const map = {};
    for (let reason of reasons) {
      map[reason.value] = reason.label;
    }
    return map;
  };

  const doQuickSave = async (
    category,
    consequenceEid,
    studentEids,
    consequenceMap,
  ) => {
    let date = getYYYYMMDD();

    let reasonId = null;
    if (category.reasons != null && category.reasons.length > 0) {
      setDialogOpen(false);
      const reasonResult = await showOptions(
        "Select a Reason",
        "Click Reason Name",
        getReasonsOptions(category.reasons),
      );
      if (!reasonResult.isConfirmed) {
        return;
      }
      reasonId = reasonResult.value;
    }

    const scores = buildScores(
      category.id,
      consequenceEid,
      "Y",

      studentEids,
      consequenceMap,
      "quick save search bar",
      null,
      "0",
      0,
      reasonId,
    );

    doService(saveScores(_school, _jwt, date, scores), (results) => {
      //clear values
      showToast(
        "S",
        "Score(s) Created",
        "Score(s) have been created successfully.",
      );
      loadUser(_selectedUser);
    });
  };

  const filteredOptions = _options.filter((option) =>
    option.title.toLowerCase().includes(_searchText.toLowerCase()),
  );

  const handleClickQuickCategory = (category) => {
    const studentEids = [_selectedUser.eid];
    return doCalculateConsequences(category, studentEids, 0);
  };

  const handleChangeFeature = (event) => {
    setFeature(event.target.value);
  };

  return (
    <>
      <FormControl fullWidth variant="standard">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "#F5F5F5",
            pl: 1,
            pr: 1,
            borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
            transition: "border-bottom-color 0.2s ease",
            "&:hover": {
              borderBottom: "2px solid rgba(0, 0, 0, 0.87)",
            },
            "&:focus-within": {
              borderBottom: "2px solid #1976d2",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              color: "action.active",
              mr: 1,
            }}
          >
            <SearchIcon />
          </Box>
          <Select
            fullWidth
            open={_open}
            value=""
            displayEmpty
            onOpen={handleOpen}
            onClose={handleClose}
            onChange={(event) => {
              const userObj = _options.find(
                (option) => option.eid === event.target.value,
              );
              onChangeUser(event, userObj);
            }}
            renderValue={() => "Search ..."}
            MenuProps={{
              autoFocus: false,
              PaperProps: {
                style: {
                  maxHeight: 420,
                },
              },
            }}
            sx={{
              backgroundColor: "#F5F5F5",
              pb: 0.5,
              "&:before": {
                display: "none",
              },
              "&:after": {
                display: "none",
              },
              "&:hover:not(.Mui-disabled, .Mui-error):before": {
                display: "none",
              },
              "& .MuiSelect-select": {
                pl: 0,
              },
            }}
          >
            <ListSubheader>
              <TextField
                autoFocus
                fullWidth
                size="small"
                placeholder="Type a name..."
                value={_searchText}
                onChange={(event) => setSearchText(event.target.value)}
                onKeyDown={(event) => {
                  event.stopPropagation();
                }}
              />
            </ListSubheader>

            {_loading && <MenuItem disabled>Loading...</MenuItem>}
            {!_loading && filteredOptions.length === 0 && (
              <MenuItem disabled>-- NO MATCHES --</MenuItem>
            )}
            {!_loading &&
              filteredOptions.map((option) => (
                <MenuItem key={option.eid} value={option.eid}>
                  {option.title}
                </MenuItem>
              ))}
          </Select>
        </Box>
      </FormControl>

      <Dialog
        onClose={onCloseDialog}
        fullWidth
        fullScreen
        open={_dialogOpen}
        PaperProps={{
          sx: {
            maxHeight: 500,
            height: 500,
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">
          Details for {_selectedUser.first_name} {_selectedUser.last_name}
          {isEmpty(_selectedUser.mi) === false && <> {_selectedUser.mi}.</>}
        </DialogTitle>

        <DialogContent>
          {_selectedUser.priority === 500 && (
            <>
              <InputLabel>Select Feature: *</InputLabel>
              <Select
                fullWidth
                size="small"
                onChange={handleChangeFeature}
                value={_feature}
              >
                <MenuItem key="A" value="A">
                  Activities
                </MenuItem>
                <MenuItem key="P" value="P">
                  Passes ({_studentPasses.length})
                </MenuItem>
                <MenuItem key="T" value="T">
                  Tardies
                </MenuItem>
                <MenuItem key="E" value="E">
                  Events
                </MenuItem>
              </Select>
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  mt: 1,
                }}
              ></Box>

              {_feature === "A" && (
                <Container
                  sx={{
                    ml: 0,
                    pl: 0,
                    mr: 0,
                    pr: 0,
                    mt: 1,
                    maxWidth: "100%",
                  }}
                >
                  <TableContainer component={Paper}>
                    <Table size="small" sx={{ mt: 0 }}>
                      <TableBody>
                        <TableRowNoResults data={_studentActivities} />
                        {_studentActivities.map((activity) => (
                          <StripedTableRow>
                            {activity.locationName === "" && (
                              <StripedTableCell>
                                <span class="activityName">
                                  {getPeriodName(_school, activity.period - 1)}:
                                  -- NONE --
                                </span>
                              </StripedTableCell>
                            )}
                            {activity.locationName !== "" && (
                              <StripedTableCell>
                                <span class="activityName">
                                  {getPeriodName(_school, activity.period - 1)}:{" "}
                                  {activity.name}
                                </span>
                                <Chip
                                  label={activity.attendanceStatus}
                                  sx={{ ml: 0.5 }}
                                />
                                <br />
                                {activity.teacherLastName},{" "}
                                {activity.teacherFirstName.substring(0, 1)} -{" "}
                                {activity.locationName},
                                {activity.courseName != null && (
                                  <><br/>(Focused for {activity.courseName})</>
                                )}
                                {activity.courseName == null && (
                                  <><br/>(Flex)</>
                                )}

                              </StripedTableCell>
                            )}
                          </StripedTableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Button
                    sx={{ mt: 2 }}
                    onClick={onClickViewStudentCalendar}
                    variant="contained"
                    size="small"
                  >
                    View Student Calendar
                  </Button>
                </Container>
              )}

              {_feature === "P" && (
                <Container
                  sx={{
                    ml: 0,
                    pl: 0,
                    mr: 0,
                    pr: 0,
                    mt: 1,
                    maxWidth: "100%",
                  }}
                >
                  {_studentPasses.length === 0 ? (
                    <>-- NO PASSES RETURNED --</>
                  ) : (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      sx={{ borderBottom: "2px solid black", mb: 1 }}
                    ></Grid>
                  )}

                  {_studentPasses.map((p) => (
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={6}>
                        <span style={{ fontWeight: "bold" }}>Approved:</span>{" "}
                        {dayjs(p.approvedAt).format("hh:mm a")} for {p.passTypeName}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <span style={{ fontWeight: "bold" }}>Status:</span>{" "}
                        {getPassStatusText(p.status)}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <span style={{ fontWeight: "bold" }}>From:</span>{" "}
                        {p.teacherLastName},{" "}
                        {p.teacherFirstName.substring(0, 1)}
                      </Grid>

                      {p.toTeacherLastName !== "None" ||
                        (p.toLocationName !== "None" && (
                          <>
                            <Grid item xs={12} sm={6} sx={{ mb: 1 }}>
                              <span style={{ fontWeight: "bold" }}>To:</span>{" "}
                              {p.toTeacherLastName !== "None" && (
                                <>
                                  {p.toTeacherLastName},{" "}
                                  {p.toTeacherFirstName.substring(0, 1)}
                                </>
                              )}
                              {p.toLocationName !== "None" && (
                                <>{p.toLocationName}</>
                              )}
                            </Grid>
                          </>
                        ))}

                      <Grid
                        item
                        xs={12}
                        sm={6}
                        sx={{ borderBottom: "2px solid black", mb: 1 }}
                      ></Grid>
                    </Grid>
                  ))}
                </Container>
              )}

              {_feature === "S" && (
                <Container
                  sx={{
                    ml: 0,
                    pl: 0,
                    mr: 0,
                    pr: 0,
                    mt: 1,
                    maxWidth: "100%",
                  }}
                >
                  <br />

                  {_scoreCategories.map((cat) => (
                    <>
                      {cat.isQuick === "Y" && (
                        <Button
                          key={cat.id}
                          sx={{
                            minHeight: 36,
                            backgroundColor: "#2f7fd1",
                            "&:hover": {
                              backgroundColor: "#256bb3",
                            },
                            mr: 1,
                          }}
                          variant="contained"
                          title={`quick ${cat.name.toLowerCase()}`}
                          onClick={() => handleClickQuickCategory(cat)}
                          startIcon={<TimerIcon style={{ fill: "#ffffff" }} />}
                        >
                          {cat.shortName}
                        </Button>
                      )}
                    </>
                  ))}

                  <br />

                  <TableContainer component={Paper} sx={{ mt: 2 }}>
                    <Table size="small">
                      <TableHead>
                        <StripedTableRow>
                          <StripedTableCell>Created</StripedTableCell>
                          <StripedTableCell>Detail</StripedTableCell>
                        </StripedTableRow>
                      </TableHead>
                      <TableBody>
                        <TableRowNoResults data={_studentScores} />
                        {_studentScores.map((score) => (
                          <StripedTableRow>
                            <StripedTableCell>
                              <b>
                                {dayjs(score.dateCreated).format("hh:mm a")}
                                {!isStringEmpty(score.period) && (
                                  <>, period {score.period}</>
                                )}
                              </b>
                              <br />
                              by: {score.teacherLastName},{" "}
                              {score.teacherFirstName}
                            </StripedTableCell>
                            <StripedTableCell>
                              <b>{score.categoryName}</b>
                              <br />
                              CON: {score.consequenceName}
                              {!isStringEmpty(score.comment) && (
                                <>
                                  <br />
                                  {score.comment}
                                </>
                              )}
                            </StripedTableCell>
                          </StripedTableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Container>
              )}

              {_feature === "E" && (
                <Container
                  sx={{
                    ml: 0,
                    pl: 0,
                    mr: 0,
                    pr: 0,
                    mt: 1,
                    maxWidth: "100%",
                  }}
                >
                  <TableContainer component={Paper}>
                    <Table size="small" sx={{ mt: 2 }}>
                      <TableBody>
                        <TableRowNoResults data={_studentEvents} />
                        {_studentEvents.map((e) => (
                          <>
                            <TableRow sx={{ borderTop: "2px solid black" }}>
                              <TableCell>Time:</TableCell>
                              <TableCell>
                                {getEventStartTime(e)}-{getEventEndTime(e)}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>Title:</TableCell>
                              <TableCell>{e.title}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>Proctor:</TableCell>
                              <TableCell>
                                {e.teacherLastName},{" "}
                                {e.teacherFirstName.substring(0, 1)}
                              </TableCell>
                            </TableRow>
                          </>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Container>
              )}
            </>
          )}

          {_selectedUser.priority > 500 && (
            <>
              {isActivitiesEnabled() === true && (
                <Accordion
                  disableGutters
                  sx={{ boxShadow: 1, p: 0, mt: 2 }}
                  expanded
                >
                  <AccordionSummary
                    className="accordionTitle"
                    expandIcon={<ExpandMoreIcon />}
                  >
                    Activity Details ({_teacherActivities.length})
                  </AccordionSummary>
                  <AccordionDetails>
                    <TableContainer component={Paper}>
                      <Table>
                        <TableBody>
                          <TableRowNoResults data={_teacherActivities} />
                          {_teacherActivities.map((activity) => (
                            <TableRow>
                              {activity.locationName === "" && (
                                <TableCell>
                                  <span class="activityName">
                                    {getPeriodName(
                                      _school,
                                      activity.period - 1,
                                    )}
                                    : -- NONE --
                                  </span>
                                </TableCell>
                              )}
                              {activity.locationName !== "" && (
                                <TableCell>
                                  <span class="activityName">
                                    {getPeriodName(
                                      _school,
                                      activity.period - 1,
                                    )}
                                    : {activity.name}
                                  </span>
                                  <Chip
                                    label={
                                      activity.attendanceTaken === 1
                                        ? "ATT TAKEN"
                                        : "ATT NOT TAKEN"
                                    }
                                    sx={{ ml: 0.5 }}
                                  />
                                  <br />
                                  {activity.locationName}
                                </TableCell>
                              )}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </AccordionDetails>
                </Accordion>
              )}

              <Accordion
                disableGutters
                sx={{ boxShadow: 1, p: 0, mt: 2 }}
                expanded
              >
                <AccordionSummary
                  className="accordionTitle"
                  expandIcon={<ExpandMoreIcon />}
                >
                  Pass Details ({_studentPasses.length})
                </AccordionSummary>
                <AccordionDetails>
                  <TableContainer component={Paper}>
                    <Table size="small">
                      <TableBody>
                        <TableRowNoResults data={_studentPasses} />
                        {_studentPasses.map((p) => (
                          <>
                            <TableRow sx={{ borderTop: "2px solid black" }}>
                              <TableCell>Approved:</TableCell>
                              <TableCell>
                                {dayjs(p.approved_at).format("hh:mm a")}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>Type:</TableCell>
                              <TableCell>{p.type_name}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>Status:</TableCell>
                              <TableCell>
                                {getPassStatusText(p.status)}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>From:</TableCell>
                              <TableCell>
                                {p.teacher_last_name},{" "}
                                {p.teacher_first_name.substring(0, 1)}
                              </TableCell>
                            </TableRow>
                            <TableRow sx={{ borderBottom: "black solid 2px" }}>
                              <TableCell>To:</TableCell>{" "}
                              {p.to_teacher_last_name != null && (
                                <TableCell>
                                  {p.to_teacher_last_name},{" "}
                                  {p.to_teacher_first_name.substring(0, 1)}
                                </TableCell>
                              )}
                              {p.to_teacher_last_name == null && (
                                <TableCell>
                                  LOCATION: {p.to_location_name}
                                </TableCell>
                              )}
                            </TableRow>
                          </>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </AccordionDetails>
              </Accordion>
            </>
          )}
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" onClick={onClickCloseDialog}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
